import * as React from 'react';
import usePosts from '../hooks/usePosts.js';
import Loading from '../widgets/Loading';
import LoadMore from './LoadMore';
import NoResults from './NoResults';
import PostsGrid from './PostsGrid';

const Posts = () => {
    let { posts, maxNumPages, page, setPage, loading } = usePosts();
    const [ isLoading, setIsLoading ] = React.useState(true);

    // Create a minimum load time to prevent flickering.
    const lastLoading = React.useRef( false );
    React.useEffect(() => {
        const minLoader = 500;

        if ( loading ) {
            lastLoading.current = new Date();
            setIsLoading( true );
        } else if ( false !== lastLoading.current ) {
            const now  = new Date();
            const diff = now.getTime() - lastLoading.current.getTime();
            
            if ( diff > minLoader ) {
                setIsLoading( false );
            } else {
                setTimeout(() => {
                    setIsLoading( false );
                }, minLoader - diff );
            }
        }
    }, [ loading ]);

    return (
        <Loading isLoading={ isLoading }>
            <div className="pfa-posts">
                <PostsGrid posts={ posts } />
                <LoadMore page={ page } maxNumPages={ maxNumPages } setPage={ setPage } />
            </div>

            <NoResults isNoResults={ ! posts.length } />
        </Loading>
    )
}

Posts.displayName = 'Posts';

export default Posts;